<div class="tabs-bar" data-theme-key="--bg-card-alt"
     [lxResponsiveClass]="{ horizontal: 'tabs-bar-horizontal', vertical: 'tabs-bar-vertical' }">
  <!-- Row 1: Nav bar always gets its own row in vertical mode -->
  <div class="tabs-row tabs-row--nav">
    <ui-new-offer-nav-bar
      [upgradeAvailability]="upgradeAvailability"
      [selectedTab]="selectedTab"
      (selectedTabChange)="selectedTabChange.emit($event)"/>
  </div>

  <!-- Row 2: Timer row (vertical) / inline (horizontal) -->
  <div class=" tabs-row--timer"
       [lxResponsiveClass]="{ horizontal: '', vertical: 'timer-handset'}">
    <app-count-down-timer
      [class.attention-flash]="flashTimerRow"
      [class.mobile-timer]="viewResponsiveMode === responsiveMode.vertical"
      [lxResponsiveClass]="{ horizontal: 'timer-card-horizontal', vertical: 'timer-card-handset-new'}"
      [endDate]="endDate">
    </app-count-down-timer>
  </div>

  <!-- Row 3: Controls row -->
  <div class="tabs-row tabs-row--controls" data-theme-key="--chip-bg">
    <button type="button" class="icon-btn" [hidden]="(offerCount ?? 0) < 4"
            [lxResponsiveClass]="{ horizontal: '', vertical: 'filter-handset'}"
            (click)="filterToggle.emit()" aria-label="Toggle filters">
      <span class="material-icons">filter_alt</span>
    </button>

    @if (viewResponsiveMode === responsiveMode.horizontal) {

      <div class="view-toggle" aria-label="View mode">
        <button
          type="button"
          class="view-toggle-btn"
          data-theme-key="--seg-active-bg"
          [class.active]="viewMode === 'tiles'"
          (click)="setViewMode('tiles')"
          aria-label="Tiles">
          <span class="material-icons">grid_view</span>
        </button>
        <button
          type="button"
          class="view-toggle-btn"
          data-theme-key="--seg-active-bg"
          [class.active]="viewMode === 'list'"
          (click)="setViewMode('list')"
          aria-label="List">
          <span class="material-icons">view_list</span>
        </button>
      </div>

    }


    @if (showCart) {
      <ui-new-shopping-cart [lxResponsiveClass]="{ horizontal: 'shopping-car', vertical: 'shopping-cart-handset' }"/>
    }
  </div>
</div>
